import { Tabs } from "@base-ui-components/react"
import { styled } from "@mui/material"

export const Tab = styled(Tabs.Tab)(({ theme }) => ({
	color: theme.palette.grey[600],
	background: "transparent",
	fontWeight: 500,
	cursor: "pointer",
	fontSize: theme.typography.fontSize * 1.25,
	width: "100%",
	lineHeight: 1.5,
	padding: "8px 12px",
	borderColor: theme.palette.grey[300],
	borderWidth: "2px",
	borderStyle: "solid",
	borderRadius: "9999px",
	display: "flex",
	justifyContent: "center",

	"&:hover": {
		backgroundColor: theme.palette.grey[100],
	},

	"&:focus": {
		outline: "none",
	},

	// [`&.${tabClasses.selected}`]: {
	// 	background: theme.palette.grey[100],
	// },
	"&.base--selected": {
		background: theme.palette.grey[100],
	},

	// [`&.${buttonClasses.disabled}`]: {
	// 	opacity: 0.5,
	// 	cursor: "not-allowed",
	// },
	"&.base--disabled": {
		opacity: 0.5,
		cursor: "not-allowed",
	},
}))
